module.exports = __webpack_public_path__ + "d074e494656b95c3ab1ed886cfb29177.svg";